var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-page',{staticClass:"om-app-404"},[_c('h1',{staticClass:"omapi-warning"},[_vm._v("404")]),_c('strong',[_vm._v("Uh oh!")]),_vm._v(" We can't find what you're looking for! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }